import React, {Component} from 'react';
import './index.scss';
import * as messages from '../../../shared/messages';
import {BannerTemplate} from "./CommonComponents";
import {HELP_DOC_URL} from "../../../constants/requiredCapabilitiesMapping";
import Moment from 'moment';
class IdpCertificateMessage extends Component {

    handleOpenHelpDocPage = () => {
        this.props.handleOpenHelpDocPage("#Topics/OneSign/SSO/SAML_.htm");
    }

    render() {
        let expirationDate = Moment.utc(this.props.expirationDate).format("DD-MMM-YYYY");
        return (
            (this.props.applicationId && this.props.messageType) ? (
                {
                    "Info":
                        <BannerTemplate bannerStyle={"info-banner"}>
                            <InfoBanner expirationDate={expirationDate}
                                        handleOpenHelpDocPage={this.handleOpenHelpDocPage}
                                        capabilities={this.props.capabilities}/>
                        </BannerTemplate>,
                }[this.props.messageType] || null
            ) : null
        );
    }
}

function InfoBanner(props) {
    return(
        <div>
            {messages.IDP_CERTIFICATE_EXPIRES.replace("expirationDate", props.expirationDate)}
            {
                (props.capabilities && props.capabilities[HELP_DOC_URL]) ? (
                    <a role="button"
                        id = "certificateBannerLearnMore"
                        className="btn btn-link link-button"
                        onClick={props.handleOpenHelpDocPage}
                    >{messages.LEARN_MORE}
                    </a>
                ) : null
            }
        </div>
    );
}

export default IdpCertificateMessage;